import FetchFactory from '../factory';
import type { OrderReceiptModel } from '~/models/order/OrderReceipt.api.model';

const CONTROLLER_PATH = '/api-electra/OrderReceipt';
const ENDPOINT_PATH = `${CONTROLLER_PATH}/GetOrderReceipt`;

class OrderReceipt extends FetchFactory<any> {
  async getReceipt(orderId: number): Promise<any> {
    return await this.get(`${ENDPOINT_PATH}/${orderId}`);
  }

  async getReceiptWithGuid(
    orderGuid: MaybeRef<string>,
  ): Promise<OrderReceiptModel> {
    return await this.get(ENDPOINT_PATH, {
      params: {
        orderGuid: unref(orderGuid),
      },
    });
  }

  async getReceiptWithSsn(
    orderId: string,
    ssn: string,
  ): Promise<OrderReceiptModel> {
    return await this.get(ENDPOINT_PATH, {
      params: {
        orderId: orderId,
        ssn: ssn,
      },
    });
  }

  async getReceiptWithZipCode(
    orderId: string,
    zipCode: string,
  ): Promise<OrderReceiptModel> {
    return await this.get(ENDPOINT_PATH, {
      params: {
        orderId,
        zipCode,
      },
    });
  }
}

export default OrderReceipt;
